import {
  jb_article_back_to_top_css_default
} from "./chunk.KJ2CQ7FE.js";
import {
  Spaceable
} from "./chunk.LK5OUX7S.js";
import {
  Rt
} from "./chunk.LQ2ZH6PS.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  getAllParents,
  scrollToTop
} from "./chunk.7QWDHXKG.js";
import {
  D,
  ke,
  r
} from "./chunk.WKUNRGJV.js";
import {
  n
} from "./chunk.LWNTGWZJ.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-article-back-to-top/jb-article-back-to-top.ts
var JbArticleBackToTop = class extends Spaceable(r) {
  constructor() {
    super(...arguments);
    this.displayStickyButtonAfterXViewportHeights = 1;
  }
  firstUpdated(_changedProperties) {
    super.firstUpdated(_changedProperties);
    if (this.sticky) {
      this._registerScrollOutCheck();
    }
  }
  _click(e) {
    e.preventDefault();
    if (this.scrollElement) {
      try {
        scrollToTop(this.scrollElement);
        return;
      } catch (err) {
      }
    }
    const elms = getAllParents(this);
    let scrolled = false;
    elms.forEach((elm) => {
      if (scrolled) return;
      const element = elm;
      if (element.clientHeight + 20 < element.scrollHeight) {
        scrollToTop(element);
        scrolled = true;
      }
    });
  }
  _moveFocusToTop() {
    const scrollToElement = document.querySelector("jb-bypass-block")?.shadowRoot.querySelector("button") || document.querySelector("jb-navigation");
    scrollToElement?.focus();
    this.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
  }
  _registerScrollOutCheck() {
    let active = true;
    window.addEventListener("scroll", () => {
      if (!active) {
        return;
      }
      active = false;
      window.setTimeout(() => {
        const elm = this.renderRoot.querySelector(".sticky");
        if (this._shouldDisplaySticky()) {
          elm?.classList.add("show");
          elm?.setAttribute("tabindex", "0");
        } else {
          elm?.classList.remove("show");
          elm?.setAttribute("tabindex", "-1");
        }
        active = true;
      }, 100);
    });
  }
  _shouldDisplaySticky() {
    const scrollPosition = window.scrollY;
    const viewPortHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    const displayAtScrollPosition = viewPortHeight * this.displayStickyButtonAfterXViewportHeights - viewPortHeight;
    return scrollPosition >= displayAtScrollPosition;
  }
  render() {
    return ke`
      <div
        class=${Rt({
      sticky: this.sticky,
      static: !this.sticky
    })}
        tabindex="${this.sticky ? "-1" : D}"
        role="button"
        @click=${this._click}
        @keyup=${(evt) => {
      if (evt.key === "Enter" || evt.code === "Space") {
        evt.preventDefault();
        this._click(evt);
        this._moveFocusToTop();
      }
    }}
        aria-label="${this.ariaLabels?.label && !this.sticky ? this.ariaLabels.label : D}"
        aria-hidden="${this.sticky ? "true" : "false"}"
      >
        ${this.sticky ? ke`
              <div class="text-wrapper">
                <span class="text">${this.text}</span>
              </div>
              <div class="icon-wrapper">
                <div class="icon"><jb-in-page-icon></jb-in-page-icon></div>
              </div>
            ` : ke`<jb-button-tertiary arrowDirection="up">${this.text}</jb-button-tertiary>`}
      </div>
    `;
  }
};
JbArticleBackToTop.styles = jb_article_back_to_top_css_default;
__decorateClass([
  n({ type: Object })
], JbArticleBackToTop.prototype, "ariaLabels", 2);
__decorateClass([
  n({ type: Number })
], JbArticleBackToTop.prototype, "displayStickyButtonAfterXViewportHeights", 2);
__decorateClass([
  n({ type: Object })
], JbArticleBackToTop.prototype, "scrollElement", 2);
__decorateClass([
  n({ type: Boolean })
], JbArticleBackToTop.prototype, "sticky", 2);
__decorateClass([
  n()
], JbArticleBackToTop.prototype, "text", 2);
JbArticleBackToTop = __decorateClass([
  customElement("jb-article-back-to-top")
], JbArticleBackToTop);

export {
  JbArticleBackToTop
};
